<template>
  <div class="page">
    <div class="page-content">
      <v-row>
        <v-col cols="3" v-for="app in apps" :key="app.id">
          <v-card class="index-card" outlined dark>
            <div class="card-header">
              <div class="index-title">{{ app.name }}</div>
              <v-menu bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small rounded v-on="on">
                    <v-icon size="15">fas fa-ellipsis-v</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="onDelete(app.id)">
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="onEdit(app)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-switch
              v-model="app.active"
              color="success"
              label="Chegagem"
              dark
              @change="onSwitch(app)"
            ></v-switch>
            <v-col cols="12" class="log-field">
              <div class="log-label">Status</div>
              <div class="log-log-value">{{ app.status }}</div>
            </v-col>
            <v-col cols="12" class="log-field">
              <div class="log-label">Última checagem</div>
              <div class="log-log-value">
                {{ app.last_check | formatDateTime }}
              </div>
            </v-col>
            <v-col cols="12" class="log-field">
              <div class="log-label">Último log</div>
              <div class="log-log-value">
                {{ app.log }}
              </div>
            </v-col>
            <v-col cols="12" class="log-field">
              <div class="log-label">Bot ativo?</div>
              <div class="log-log-value">
                {{ app.slackbot ? 'Sim' : 'Não' }}
              </div>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="form.open" dark max-width="600">
      <v-card dark>
        <v-card-title>
          <span class="headline"
            >{{ form.id ? 'Edita' : 'Adiciona' }} aplicação</span
          >
        </v-card-title>
        <v-col cols="12">
          <v-text-field
            v-model="form.name"
            label="Nome"
            dark
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="form.url"
            label="Endereço de checagem"
            dark
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="form.slackbot"
            label="Bot de alerta"
            dark
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="form.open = false"
            >Fechar</v-btn
          >
          <v-btn color="blue darken-1" text @click="onSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      left
      :timeout="1000"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <v-btn class="mx-2" fab dark color="indigo" @click="onEdit">
      <v-icon dark>fas fa-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { LogCheck } from '../service/Api'
import * as _ from 'lodash'
import moment from 'moment'
export default {
  name: 'Logaudit',
  data: () => ({
    apps: [],
    form: {
      open: false,
      name: '',
      url: '',
      slackbot: '',
      id: '',
    },
    snackbar: {
      open: false,
      message: '',
      color: 'info',
    },
  }),
  filters: {
    formatDateTime(value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      LogCheck.list()
        .then(data => {
          this.apps = _.get(data, 'data', [])
        })
        .catch(err => {
          this.snackbar = {
            open: true,
            message: _.get(
              err,
              'response.data.message',
              'Falha ao buscar apps'
            ),
            color: 'error',
          }
        })
    },
    onEdit(app) {
      this.form = {
        open: true,
        name: _.get(app, 'name', ''),
        url: _.get(app, 'url', ''),
        slackbot: _.get(app, 'slackbot', ''),
        id: _.get(app, 'id', ''),
        active: _.get(app, 'active', false),
      }
    },
    onDelete(id) {
      LogCheck.delete(id)
        .then(() => {
          this.snackbar = {
            open: true,
            message: 'Aplicação deletada',
            color: 'success',
          }
          this.loadData()
        })
        .catch(err => {
          this.snackbar = {
            open: true,
            color: 'error',
            message: 'Falha ao deletar aplicação',
          }
        })
    },
    onSave() {
      const { id, name, url, slackbot, active } = this.form
      if (id) {
        LogCheck.update(id, {
          name,
          url,
          slackbot,
          active: true,
        })
          .then(() => {
            this.snackbar = {
              open: true,
              message: 'Aplicação atualizada',
              color: 'success',
            }
            this.form = {
              open: false,
              name: '',
              url: '',
              slackbot: '',
              id: '',
            }
            this.loadData()
          })
          .catch(err => {
            this.snackbar = {
              open: true,
              color: 'error',
              message: 'Falha ao atualizar aplicação',
            }
          })
      } else {
        LogCheck.add({
          name,
          url,
          slackbot,
          active,
        })
          .then(() => {
            this.form = {
              open: false,
              name: '',
              url: '',
              slackbot: '',
              id: '',
            }
            this.snackbar = {
              open: true,
              message: 'Aplicação acriada',
              color: 'success',
            }
            this.loadData()
          })
          .catch(err => {
            this.snackbar = {
              open: true,
              color: 'error',
              message: 'Falha ao criar aplicação',
            }
          })
      }
    },
    onSwitch(app) {
      const { id, name, url, slackbot, active } = app
      LogCheck.update(id, {
        name,
        url,
        slackbot,
        active,
      })
        .then(() => {
          this.snackbar = {
            open: true,
            message: 'Aplicação atualizada',
            color: 'success',
          }
          this.loadData()
        })
        .catch(err => {
          this.snackbar = {
            open: true,
            color: 'error',
            message: 'Falha ao atualizar aplicação',
          }
        })
    },
  },
}
</script>

<style lang="scss">
.index-card {
  padding: 10px;
}
.card-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .index-title {
    font-size: 14px;
    padding: 5px;
    text-align: left;
  }
}
.log-field {
  text-align: left;
  .log-label {
    font-size: 900;
  }
  .log-value {
    font-size: 13px;
  }
}
</style>
